import { BreadcrumbProps, Button, Icon, NumberDisplay, Tooltip } from '@aidkitorg/component-library';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePayments } from '../../Contexts/PaymentsContext';
import { useLocalizedStrings } from '../../Localization';
import { AdminPanelPage } from '../AdminPanelPage';
import { PaymentBatchDownloadModal } from './components/PaymentBatchDownloadModal';
import { PaymentBatchRecipientsDataTable } from './components/PaymentBatchRecipientsDataTable';

export const PaymentBatchDetailsPage = () => {
  const { batch_name } = useParams<{ batch_name: string }>()
  const [downloadModalOpen, setDownloadModalOpen] = useState<boolean>(false)
  const L = useLocalizedStrings()
  const { 
    fetchRecipientDetailsByBatch,
    getBatchTimestamp, 
    getBatchNumRecipients, 
    getBatchName,
    getBatchNumFailedPayments,

    getIsBatchLoading,
  } = usePayments();

  const paymentBatchTimestamp = getBatchTimestamp(batch_name)
  const paymentBatchNumRecipients = getBatchNumRecipients(batch_name)
  const paymentBatchName = getBatchName(batch_name)
  const paymentBatchNumFailedPayments = getBatchNumFailedPayments(batch_name)

  const isPaymentBatchLoading = getIsBatchLoading(batch_name)

  const totalRecipientsCard = <NumberDisplay 
    title={L.admin_panel.payments.total_recipients}
    value={paymentBatchNumRecipients}
    iconName="UsersIcon"
    iconColor='blue'
    loading={isPaymentBatchLoading}
  />

  const numFailedPaymentsCard = <NumberDisplay
    title={L.admin_panel.payments.failed_payments}
    value={paymentBatchNumFailedPayments}
    iconName="XCircleIcon"
    iconColor='red'
    loading={isPaymentBatchLoading}
  />

  const breadcrumbs: BreadcrumbProps['items'] = [
    {
      label: L.admin_panel.nav.payments,
      href: '/admin-panel/payments'
    },
    ...((isPaymentBatchLoading || !paymentBatchName) ? [] : [{
      label: `${paymentBatchName}`,
    }])
  ];
  
  return (
    <AdminPanelPage
      breadcrumbs={breadcrumbs}
      title={`${paymentBatchName}`}
      description={!isPaymentBatchLoading && L.admin_panel.payments.payment_details_desc}
      pageActionButtons={[
        <Tooltip text={L.admin_panel.payments.refresh_data} asChild>
          <Button
            size="sm"
            variant='secondary'
            onClick={async () => {
              await fetchRecipientDetailsByBatch(batch_name, true)
            }}
            icon={<Icon role="decorative" type="solid" name="ArrowPathIcon" />}
            aria-label={L.admin_panel.payments.refresh_data}
          />
        </Tooltip>,
        <Tooltip text={L.admin_panel.payments.export_recipients} asChild>
          <Button size="sm" variant="secondary" onClick={() => setDownloadModalOpen(true)} disabled={isPaymentBatchLoading}>
            <div className="flex gap-2 items-center">
              <Icon name="ArrowDownTrayIcon" role="decorative" type="solid" />
            </div>
          </Button>
        </Tooltip>
      ]}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col lg:flex-row gap-2">
          <div className="w-full lg:w-auto">
            {totalRecipientsCard}
          </div>
          <div className="w-full lg:w-auto">
            {numFailedPaymentsCard}
          </div>
        </div>
        <PaymentBatchRecipientsDataTable lastUpdatedTimestamp={paymentBatchTimestamp}/>
        <PaymentBatchDownloadModal batchName={batch_name} downloadModalOpen={downloadModalOpen} setDownloadModalOpen={setDownloadModalOpen} />
      </div>
    </AdminPanelPage>
  )
}